import React, { useState, useEffect } from "react";
import { db } from "./firebase";
import {
  collection,
  addDoc,
  doc,
  getDoc,
  getDocs,
  deleteDoc,
  updateDoc,
  writeBatch,
  setDoc,
  onSnapshot,
} from "firebase/firestore";
import "./App.css";

const matchId = "match1";
const PASSWORD = "yamen102030";

function App() {
  const [players, setPlayers] = useState([]);
  const [matchName, setMatchName] = useState("");
  const [ratings, setRatings] = useState({});
  const [averages, setAverages] = useState({});
  const [animate, setAnimate] = useState({});
  const [loading, setLoading] = useState(true);
  const [manOfTheMatch, setManOfTheMatch] = useState(null);
  const [allRatings, setAllRatings] = useState({});
  const [disabled, setDisabled] = useState(false);
  const [resetAt, setResetAt] = useState(0);

  const getImagePath = (imageName) => {
    if (!imageName) return "/images/default.jpg";
    return `/images/${imageName}`;
  };

  useEffect(() => {
    const fetchMatchAndRatings = async () => {
      try {
        const matchRef = doc(db, "matches", matchId);
        const matchSnap = await getDoc(matchRef);
        if (!matchSnap.exists()) {
          alert("⚠️ المباراة غير موجودة.");
          return;
        }

        const data = matchSnap.data();
        setMatchName(data.name || "");

        const allPlayers = data.players || [];
        const selectedIds =
          data.selectedPlayers && data.selectedPlayers.length > 0
            ? data.selectedPlayers
            : allPlayers.map((p) => p.id);
        const selectedPlayers = allPlayers.filter((p) =>
          selectedIds.map(String).includes(p.id)
        );
        setPlayers(selectedPlayers);

        const ratingsSnap = await getDocs(
          collection(db, `matches/${matchId}/ratings`)
        );
        const ratingsData = {};
        ratingsSnap.forEach((d) => {
          const r = d.data();
          if (!ratingsData[r.playerId]) ratingsData[r.playerId] = [];
          ratingsData[r.playerId].push(r.value);
        });
        setAllRatings(ratingsData);

        const avg = {};
        selectedPlayers.forEach((p) => {
          const values = ratingsData[p.id] || [];
          avg[p.id] =
            values.length > 0
              ? (
                  values.reduce((a, b) => a + b, 0) / values.length
                ).toFixed(1)
              : "-";
        });
        setAverages(avg);

        // جلب حالة التحكم والتوقيت الأخير لإعادة الضبط
        const controlRef = doc(db, "matches", matchId, "control", "state");
        const unsubscribe = onSnapshot(controlRef, (snap) => {
          if (snap.exists()) {
            const data = snap.data();
            setDisabled(data.isDisabled || false);
            setResetAt(data.resetAt || 0);
          }
        });

      } catch (error) {
        console.error(error);
        alert("حدث خطأ أثناء جلب البيانات.");
      } finally {
        setLoading(false);
      }
    };
    fetchMatchAndRatings();
  }, []);

  const canVote = () => {
    const votedAt = parseInt(localStorage.getItem(`voted_${matchId}`)) || 0;
    return votedAt < resetAt;
  };

  const handleRate = (playerId, value) => {
    if (disabled) {
      alert("❌ لا يمكنك التقييم الآن. التقييم مغلق.");
      return;
    }
    if (!canVote()) {
      alert("❌ لقد صوت مسبقًا لهذه المباراة.");
      return;
    }

    setRatings((prev) => ({ ...prev, [playerId]: value }));

    const prevValues = allRatings[playerId] || [];
    const combined = [...prevValues, value];
    setAverages((prev) => ({
      ...prev,
      [playerId]: (
        combined.reduce((a, b) => a + b, 0) / combined.length
      ).toFixed(1),
    }));

    setAnimate((prev) => ({ ...prev, [playerId]: true }));
    setTimeout(() => setAnimate((prev) => ({ ...prev, [playerId]: false })), 500);
  };

  const handleSave = async () => {
    if (disabled) {
      alert("❌ لا يمكنك الحفظ لأن التقييم متوقف.");
      return;
    }
    if (!canVote()) {
      alert("❌ لقد صوت مسبقًا لهذه المباراة.");
      return;
    }

    try {
      for (const playerId in ratings) {
        await addDoc(collection(db, `matches/${matchId}/ratings`), {
          playerId,
          value: ratings[playerId],
          createdAt: new Date(),
        });

        setAllRatings((prev) => ({
          ...prev,
          [playerId]: [...(prev[playerId] || []), ratings[playerId]],
        }));
      }

      setRatings({});

      const newAvg = {};
      players.forEach((p) => {
        const values = allRatings[p.id] || [];
        newAvg[p.id] =
          values.length > 0
            ? (values.reduce((a, b) => a + b, 0) / values.length).toFixed(1)
            : "-";
      });
      setAverages(newAvg);

      let maxAvg = -1;
      let best = null;
      players.forEach((p) => {
        const a = parseFloat(newAvg[p.id]);
        if (!isNaN(a) && a > maxAvg) {
          maxAvg = a;
          best = p;
        }
      });
      setManOfTheMatch(best);

      // حفظ توقيت التصويت في localStorage
      localStorage.setItem(`voted_${matchId}`, Date.now());
      alert("✅ تم حفظ تقييمك!");
    } catch (error) {
      console.error(error);
      alert("حدث خطأ أثناء الحفظ.");
    }
  };

  const toggleDisabled = async () => {
    const input = window.prompt("أدخل كلمة السر لتغيير حالة التقييم:");
    if (input !== PASSWORD) {
      alert("كلمة السر غير صحيحة!");
      return;
    }

    try {
      const controlRef = doc(db, "matches", matchId, "control", "state");
      const snap = await getDoc(controlRef);
      const currentState = snap.exists() ? snap.data().isDisabled : false;
      const newState = !currentState;
      await updateDoc(controlRef, { isDisabled: newState });
      setDisabled(newState);
      alert(newState ? "🚫 تم إيقاف التقييم للجميع." : "✅ تم تشغيل التقييم للجميع.");
    } catch (error) {
      console.error(error);
      alert("حدث خطأ أثناء تحديث حالة التقييم.");
    }
  };

  const handleNewMatch = async () => {
    const input = window.prompt("أدخل كلمة السر لتأكيد بدء مباراة جديدة:");
    if (input !== PASSWORD) return;
    if (!window.confirm("هل تريد مسح كل التقييمات وبدء مباراة جديدة؟")) return;

    try {
      const ratingsRef = collection(db, `matches/${matchId}/ratings`);
      const snapshot = await getDocs(ratingsRef);

      // مسح كل التقييمات
      const batch = writeBatch(db);
      snapshot.docs.forEach((d) => batch.delete(d.ref));
      await batch.commit();

      // تحديث resetAt في Firestore ليتمكن جميع المستخدمين من التصويت مرة جديدة
      const controlRef = doc(db, "matches", matchId, "control", "state");
      const now = Date.now();
      await updateDoc(controlRef, { resetAt: now });

      // تحديث محليًا
      setRatings({});
      setAverages({});
      setAllRatings({});
      setManOfTheMatch(null);

      alert("✅ تم مسح التقييمات! جميع المستخدمين يمكنهم التصويت مرة أخرى.");
    } catch (error) {
      console.error(error);
      alert("حدث خطأ أثناء بدء مباراة جديدة.");
    }
  };

  if (loading)
    return (
      <h2 style={{ textAlign: "center", marginTop: "50px", color: "white" }}>
        جارٍ التحميل...
      </h2>
    );

  const mid = Math.ceil(players.length / 2);
  const leftPlayers = players.slice(0, mid);
  const rightPlayers = players.slice(mid);

  return (
    <div
      style={{
        position: "relative",
        minHeight: "100vh",
        direction: "rtl",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage: `url(${getImagePath("manu.jpg")})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          filter: "blur(2px) brightness(0.22) saturate(0.6)",
          transform: "scale(1.03)",
          zIndex: 0,
        }}
      />
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(255,255,255,0.15)",
          zIndex: 1,
        }}
      />
      <div style={{ position: "relative", zIndex: 2, padding: "20px" }}>
        <h1 style={{ textAlign: "center", marginBottom: "20px", color: "white" }}>
          {matchName || "تقييم المباراة"}
        </h1>

        <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
          <div style={{ flex: "1 1 300px", display: "flex", flexDirection: "column", gap: "12px" }}>
            {leftPlayers.map((p) => (
              <PlayerCard
                key={p.id}
                player={p}
                ratings={ratings}
                handleRate={handleRate}
                averages={averages}
                animate={animate}
                getImagePath={getImagePath}
              />
            ))}
          </div>

          <div style={{ flex: "1 1 300px", display: "flex", flexDirection: "column", gap: "12px" }}>
            {rightPlayers.map((p) => (
              <PlayerCard
                key={p.id}
                player={p}
                ratings={ratings}
                handleRate={handleRate}
                averages={averages}
                animate={animate}
                getImagePath={getImagePath}
              />
            ))}
          </div>
        </div>

        <div style={{ marginTop: "18px", display: "flex", gap: "12px", justifyContent: "center", flexWrap: "wrap" }}>
          <button onClick={handleSave} style={{ padding: "12px 20px", background: "linear-gradient(90deg,#FF5722,#FFC107)", color: "white", border: "none", borderRadius: "8px", cursor: "pointer", fontSize: "16px" }}>
            حفظ التقييمات
          </button>

          <button onClick={toggleDisabled} style={{ padding: "12px 20px", background: "linear-gradient(90deg,#9C27B0,#E91E63)", color: "white", border: "none", borderRadius: "8px", cursor: "pointer", fontSize: "16px" }}>
            {disabled ? "تشغيل التقييم" : "إيقاف التقييم"}
          </button>

          <button onClick={handleNewMatch} style={{ padding: "12px 20px", background: "linear-gradient(90deg,#1976D2,#29B6F6)", color: "white", border: "none", borderRadius: "8px", cursor: "pointer", fontSize: "16px" }}>
            بدء مباراة جديدة
          </button>
        </div>

        {manOfTheMatch && (
          <div style={{ marginTop: "36px", textAlign: "center" }}>
            <h2 style={{ margin: "10px 0 6px 0", color: "white" }}>
              🏆 رجل المباراة: {manOfTheMatch.name}
            </h2>
            <img
              src={getImagePath(manOfTheMatch.photo)}
              alt={manOfTheMatch.name}
              style={{
                width: "110px",
                height: "110px",
                borderRadius: "50%",
                objectFit: "cover",
                boxShadow: "0 8px 22px rgba(0,0,0,0.35)",
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
}

function PlayerCard({ player, ratings, handleRate, averages, animate, getImagePath }) {
  return (
    <div style={{ display: "flex", alignItems: "center", background: "rgba(255,255,255,0.04)", padding: "10px", borderRadius: "8px" }}>
      <img src={getImagePath(player.photo)} alt={player.name} style={{ width: "80px", height: "80px", borderRadius: "50%", marginLeft: "18px", objectFit: "cover" }} />
      <div style={{ flex: 1 }}>
        <h3 style={{ margin: "0 0 8px 0", color: "white" }}>{player.name}</h3>
        <div>
          {[...Array(10)].map((_, idx) => {
            const value = idx + 1;
            const baseColor = value <= 4 ? "#e53935" : value <= 6.5 ? "#fb8c00" : "#43a047";
            const isSelected = ratings[player.id] === value;
            return (
              <button key={value} onClick={() => handleRate(player.id, value)} style={{ margin: "3px", padding: "8px 12px", minWidth: "38px", borderRadius: "6px", border: "none", cursor: "pointer", color: "white", backgroundColor: isSelected ? "#505050" : baseColor }}>
                {value}
              </button>
            );
          })}
        </div>
        {averages[player.id] && (
          <div style={{ marginTop: "8px", display: "inline-block", padding: "6px 12px", borderRadius: "8px", color: "white", fontWeight: "700", backgroundColor: parseFloat(averages[player.id]) <= 4 ? "#e53935" : parseFloat(averages[player.id]) <= 6.5 ? "#fb8c00" : "#43a047", transform: animate[player.id] ? "scale(1.25)" : "scale(1)", transition: "all 0.35s ease" }}>
            متوسط: {averages[player.id]}
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
